import { Box, Button, Dialog, DialogActions, DialogContent, FormControl, FormLabel, Grid, TextField, Typography } from '@mui/material';
import { ChangeEvent, FC, useState } from 'react'
import Select, { SingleValue } from 'react-select';

import { useDispatch } from 'react-redux';
import { palette } from 'src/theme/style/palette';
import { usePostBodyWithJwtMutation } from 'src/redux/api/cabinet';
import { iLogout } from 'src/redux/slices/app';
import { currencyList } from 'src/components/shared/constants/currencyList';
import { Alerting } from 'src/views/components_cabinet/Alerting';

const customStyles = {
    control: (base: any) => ({
        ...base,
        padding: '2px 6px',
        width: '100%',
        height: "94px",
        backgroundColor: "rgba(255, 255, 255, 0.2) !important",
        backdropFilter: "blur(12px)",
        WebkitBackdropFilter: "blur(12px)",
        border: `1px solid ${palette.blue}`,
        borderRadius: '4px',
        '&:hover': {
            borderColor: palette.blue,
        },
    }),
    menu: (base: any) => ({
        ...base,
        borderRadius: '4px',
        boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
    }),
    option: (base: any, state: any) => ({
        ...base,
        backgroundColor: state.isSelected ? palette.blue : base.backgroundColor,
        color: state.isSelected ? '#fff' : base.color,
        '&:hover': {
            backgroundColor: palette.blueLight,
            color: '#000',
        },
    }),
    placeholder: (base: any) => ({
        ...base,
        color: palette.blue,
    }),
};

interface CurrencyOption {
    label: string;
    value: string;
}

interface Props {
    reloadList: () => void;
}

export const P2pAddReqviz: FC<Props> = ({ reloadList }) => {
    const dispatch = useDispatch();
    const [getAlert, setAlert] = useState<{ type: number; msg: string } | undefined>(undefined);
    const [selectedCurrency, setSelectedCurrency] = useState<SingleValue<CurrencyOption>>({ label: 'Выбрать', value: '' });
    const [newRequisiteArray, setNewRequisiteArray] = useState<{ bank: string, currency: string, requisite: string }>({ bank: '', currency: '', requisite: '' });

    const [modal, setModal] = useState(false);
    const closeModal = () => setModal(false);
    const openModal = () => setModal(true);

    const updateNewRequisiteBank = (bank: string) => {
        if (bank.length > 100) return; // Ограничиваем ввод до 20 символов

        setNewRequisiteArray(prev => ({
            ...prev,
            bank
        }));
    };

    const updateNewRequisiteCurrency = (selectedOption: SingleValue<CurrencyOption>) => {

        const currency = selectedOption?.value || '';
        setSelectedCurrency(selectedOption);
        setNewRequisiteArray(prev => ({
            ...prev,
            currency
        }));

    };

    const updateNewRequisiteRequisite = (requisite: string) => {
        if (requisite.length > 100) return;

        setNewRequisiteArray(prev => ({
            ...prev,
            requisite
        }));
    };

    // ЗАПРОС СОЗДАНИЕ
    const [getData, { isLoading }] = usePostBodyWithJwtMutation();

    const getDataFunction = async (data: any = []) => {
        const jwt = localStorage.getItem('jwt');

        try {
            await getData({
                body: data,
                route: 'p2p-account-add',
                jwt,
            }).unwrap();

            reloadList();
            closeModal();
            setNewRequisiteArray({ bank: '', currency: '', requisite: '' });
            setSelectedCurrency({ label: 'Выбрать', value: '' });
        } catch (error: any) {
            if (error.data?.message === 'Unauthenticated.') dispatch(iLogout());
            setAlert({ type: 2, msg: error.data?.message });
        }
    }

    const addNewRequisites = () => {
        const data = {
            bank: newRequisiteArray.bank,
            currency: newRequisiteArray.currency,
            account: newRequisiteArray.requisite,
        };

        getDataFunction(data);
    }

    return (
        <>

            <Button onClick={openModal} variant='outlined'>Добавить реквизиты</Button>

            <Dialog
                open={modal}
                maxWidth='lg'
                fullWidth
                onClose={closeModal}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                {/* <pre>
                                    {JSON.stringify(editReqvizitData, null, 2)}
                                </pre> */}
                <DialogContent sx={{ position: 'relative' }}>
                    <Typography variant="h4" textAlign='start' sx={{ mb: 3 }}>Создание</Typography>

                    <Box width='100%'>
                        <Grid container spacing={2}>
                            <Grid item xs={12} md={6} lg={4} display='flex'>
                                <Box width="100%">
                                    <FormControl fullWidth>
                                        <FormLabel sx={{ mb: 1 }}>Название банка/Платёжной системы</FormLabel>
                                        <TextField
                                            variant="outlined"
                                            multiline
                                            rows={2} // Количество строк
                                            value={newRequisiteArray.bank}
                                            placeholder="Название банка или тип перевода"
                                            onChange={(e: ChangeEvent<HTMLInputElement>) => updateNewRequisiteBank(e.target.value)}
                                            helperText={<Typography component="span" variant='body2' sx={{ fontWeight: 600, color: (100 - newRequisiteArray.bank.length) < 5 ? palette.error : 'auto' }}>Осталось {100 - newRequisiteArray.bank.length} символов</Typography>}
                                        />
                                    </FormControl>
                                </Box>
                            </Grid>

                            <Grid item xs={12} md={6} lg={4} display='flex'>
                                <Box width="100%">
                                    <FormControl fullWidth>
                                        <FormLabel sx={{ mb: 1 }}>Имя/Счет/Карта/Реквизиты/СБП/Телефоны</FormLabel>
                                        <TextField
                                            variant="outlined"
                                            multiline
                                            rows={2} // Количество строк
                                            value={newRequisiteArray.requisite}
                                            placeholder="Опишите как вы хотите получить платёж"
                                            onChange={(e: ChangeEvent<HTMLInputElement>) => updateNewRequisiteRequisite(e.target.value)}
                                            helperText={<Typography component="span" variant='body2' sx={{ fontWeight: 600, color: (100 - newRequisiteArray.requisite.length) < 5 ? palette.error : 'auto' }}>Осталось {100 - newRequisiteArray.requisite.length} символов</Typography>}
                                        />
                                    </FormControl>
                                </Box>
                            </Grid>
                            <Grid item xs={12} md={6} lg={4} display='flex'>
                                <Box width="100%">
                                    <FormControl fullWidth>
                                        <FormLabel sx={{ mb: 1 }}>Выберите валюту для этих реквизитов.</FormLabel>
                                        <Select<CurrencyOption>
                                            value={selectedCurrency}
                                            onChange={updateNewRequisiteCurrency}
                                            options={currencyList}
                                            getOptionLabel={(e: CurrencyOption) => e.label}
                                            getOptionValue={(e: CurrencyOption) => e.value}
                                            placeholder="Выберите валюту"
                                            isSearchable={true}
                                            styles={{
                                                ...customStyles,
                                                menuPortal: (base: any) => ({
                                                    ...base,
                                                    zIndex: 9999,
                                                }),
                                            }}
                                            menuPortalTarget={document.body}
                                        />
                                    </FormControl>
                                </Box>
                            </Grid>
                        </Grid>

                        <Box sx={{ mt: 3 }}>
                            <Button
                                disabled={isLoading}
                                onClick={() => addNewRequisites()}
                                variant="contained">Добавить новый реквизит</Button>
                        </Box>
                    </Box>
                </DialogContent>
                <DialogActions>
                    <Button onClick={closeModal}>Закрыть</Button>
                </DialogActions>
            </Dialog>

            {getAlert && <Alerting get={getAlert} />}
        </>

    )
}
